import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { mutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { z } from 'zod';
import type { Voucher } from '../types/voucher.type';

export const UpdateVoucherSchema = z.object({
  voucher_code: z.string().min(1, {
    message: 'Kode voucher tidak boleh kosong!',
  }),
  type: z.enum(['FLAT', 'PERCENTAGE'], {
    message: 'Tipe voucher tidak valid!',
  }),
  discount: z.number({ message: 'Diskon harus berupa angka!' }),
  stock: z.number({ message: 'Stok harus berupa angka!' }),
  expired_at: z.string().min(1, {
    message: 'Tanggal kadaluarsa tidak boleh kosong!',
  }),
});
export type UpdateVoucherData = z.infer<typeof UpdateVoucherSchema>;
export type UpdateVoucherPayload = {
  voucher_id: string;
  data: UpdateVoucherData;
};
export type UpdateVoucherResponse = ApiResponse<Voucher>;

export const updateVoucher = async (
  payload: UpdateVoucherPayload
): Promise<UpdateVoucherResponse> => {
  const { voucher_id, data } = payload;
  const url = `voucher/${voucher_id}`;

  return await apiClient.patch(url, data);
};

export function updateVoucherMutationOptions() {
  return mutationOptions<
    UpdateVoucherResponse,
    AxiosError,
    UpdateVoucherPayload
  >({
    mutationFn: updateVoucher,
  });
}
